<template>
    <span class="block text-slate-500 text-sm font-normal">
        or {{ formatPriceInCents(item.min_rate) }} for {{ calcNights }} night{{
            calcNights > 1 ? 's' : ''
        }}
    </span>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import { computed } from 'vue';
import Filters from '@/filters';

const store = useCalendarStore();
const { view } = storeToRefs(store);
const { formatPriceInCents } = Filters;
const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
    nights: {
        type: Number,
        default: 1,
    },
});

const calcNights = computed(() => {
    if (view.value === 'year') {
        return 1;
    }
    if (view.value === 'list') {
        return 1;
    }
    if (view.value === 'day') {
        return 1;
    }
    return props.nights;
});
</script>
